/**
 * Utilitário SEO — atualiza title, meta description e Open Graph via DOM.
 * Compatível com Google Bot (crawlável via JavaScript).
 */

function setMetaTag(nameOrProperty, content) {
  if (!content) return;
  const isOg = nameOrProperty.startsWith('og:') || nameOrProperty.startsWith('twitter:');
  const attr = isOg ? 'property' : 'name';
  let el = document.querySelector(`meta[${attr}="${nameOrProperty}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, nameOrProperty);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setCanonical(url) {
  // Prefer the element with id="canonical-tag" inserted before React loads
  let el = document.getElementById('canonical-tag') || document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    el.id = 'canonical-tag';
    document.head.appendChild(el);
  }
  el.setAttribute('href', url);
}

function injectJsonLd(id, data) {
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement('script');
    el.id = id;
    el.type = 'application/ld+json';
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

export function updateSEO({ title, description, ogImage, ogUrl, ogType = 'website' }) {
  const base = 'https://agrourbanglobal.com';
  const fullUrl = ogUrl ? (ogUrl.startsWith('http') ? ogUrl : `${base}${ogUrl}`) : window.location.href;

  if (title) document.title = title;
  setMetaTag('description', description);
  setMetaTag('og:type', ogType);
  setMetaTag('og:title', title);
  setMetaTag('og:description', description);
  setMetaTag('og:url', fullUrl);
  setMetaTag('og:site_name', 'Agro Urban Global');
  if (ogImage) {
    const imgUrl = ogImage.startsWith('http') ? ogImage : `${base}${ogImage}`;
    setMetaTag('og:image', imgUrl);
    setMetaTag('twitter:image', imgUrl);
  }
  setMetaTag('twitter:card', 'summary_large_image');
  setMetaTag('twitter:title', title);
  setMetaTag('twitter:description', description);
  setCanonical(fullUrl);
}

export function injectRochaJsonLd() {
  injectJsonLd('jsonld-rocha', {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'Rocha Climatização',
    description: 'Peças e serviços de ar condicionado em Palmas-TO. Compressores, tubos de cobre, gás refrigerante e muito mais.',
    url: 'https://agrourbanglobal.com/parceiros/rocha',
    logo: 'https://agrourbanglobal.com/rocha_yinyang.png',
    image: 'https://agrourbanglobal.com/rocha_yinyang.png',
    telephone: '+55-63-3322-4310',
    email: 'rochaclimatiza@gmail.com',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Palmas',
      addressRegion: 'TO',
      postalCode: '77000-000',
      addressCountry: 'BR',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: -10.2491,
      longitude: -48.3243,
    },
    openingHoursSpecification: [
      { '@type': 'OpeningHoursSpecification', dayOfWeek: ['Monday','Tuesday','Wednesday','Thursday','Friday'], opens: '08:00', closes: '18:00' },
      { '@type': 'OpeningHoursSpecification', dayOfWeek: ['Saturday'], opens: '08:00', closes: '12:00' },
    ],
    sameAs: [
      'https://www.instagram.com/rochaclimatizacaopmw/',
      'https://www.facebook.com/rochaclimatizacao16/',
    ],
    priceRange: 'R$',
    servesCuisine: null,
  });
}

export function injectProductJsonLd(product, partnerName = 'Rocha Climatização') {
  const base = 'https://agrourbanglobal.com';
  injectJsonLd('jsonld-product', {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: product.name,
    description: product.description || `${product.name} — peça para ar condicionado. Disponível em Palmas-TO.`,
    brand: { '@type': 'Brand', name: partnerName },
    image: product.images?.map(img => img.startsWith('http') ? img : `${base}${img}`) || [],
    offers: {
      '@type': 'Offer',
      priceCurrency: 'BRL',
      price: product.sale_price || product.regular_price || 0,
      availability: product.in_stock !== false ? 'https://schema.org/InStock' : 'https://schema.org/OutOfStock',
      seller: { '@type': 'Organization', name: partnerName },
      url: `${base}/parceiros/rocha/produto/${product.id}`,
    },
  });
}
